<template>
    <div class="empty-catalog">
        <div class="empty-catalog-header">
            <h2>По вашему запросу ничего не нашлось</h2>

            <div v-if="similarProducts.length" class="similar-products">
                <h3 class="section-title mt-0 mb-4">Похожие товары:</h3>

                <carousel classes="bestseller-carousel slides-4" :items="similarProducts"
                          :options="options"
                          :show-navigation="showNavigation"
                          :change-overflow="true">
                    <template #slide="{ item }">
                        <card :product="item"></card>
                    </template>
                </carousel>
            </div>

            <p>Возможно, Вы найдете другие интересные модели в одном из разделов:</p>

            <ul class="nav">
                <li class="nav-item woman">
                    <a class="nav-link" href="/catalog/woman/">
                        <div></div>
                        Женская обувь
                    </a>
                </li>
                <li class="nav-item man">
                    <a class="nav-link" href="/catalog/man/">
                        <div></div>
                        Мужская обувь
                    </a>
                </li>
                <li class="nav-item bags">
                    <a class="nav-link" href="/catalog/bags_woman/">
                        <div></div>
                        Сумки
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import Carousel from "../Carousel/Carousel";
import {mapState} from "vuex";

export default {
    name: "Empty",
    components: {
        Carousel
    },
    data() {
        return {
            options: {
                loop: true,
                spaceBetween: 5,
                breakpoints: {
                    1200: {
                        slidesPerView: 4,
                    },
                    1024: {
                        slidesPerView: 3,
                    },
                    768: {
                        slidesPerView: 3,
                    },
                    640: {
                        slidesPerView: 3,
                    },
                    576: {
                        slidesPerView: 3,
                    },
                    320: {
                        slidesPerView: 2,
                    }
                },
            },
        }
    },
    computed: {
        ...mapState('catalog', [
            'similarProducts',
        ]),

        showNavigation() {
            return !((this.windowWidth <= 640 && this.bestsellers.length <= 1)
                || (this.windowWidth <= 768 && this.bestsellers.length <= 2)
                || (this.windowWidth <= 1024 && this.bestsellers.length <= 3)
                || (this.windowWidth > 1024 && this.bestsellers.length <= 4)
            );
        }
    },
}
</script>
